import { Box, Button, Modal, Stack, styled } from '@mui/material';

export const ResourceSelectorSidebarHeaderContainer = styled(Stack)`
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const ResourceSelectorSidebarHeaderButton = styled(Button)(
  ({ theme }) => `
    padding: 0;
    color: ${theme.palette.text.primary};
    font-size: 1.25rem;
    font-weight: 400;
    `,
);

export const UploadInProgress = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledUploadBox = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'isDragging',
})(
  ({ theme, isDragging }) => `
  border: 1px dashed ${theme.palette.primary.main};
  padding: 20px;
  text-align: center;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background-color: ${
    isDragging ? theme.palette.brand?.lightBlue : 'transparent'
  };

  &:hover {
    background-color: ${theme.palette.brand?.lightBlue};
  }
`,
);

export const StyledText = styled('label')(
  ({ theme }) => `
  color: ${theme.palette.primary.main};
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
  `,
);
